<template>
  <div>
    <h1 class="page-header">{{ $t('event.event') }}</h1>
    <div class="row">
      <div
        class="col-md-5 col-sm-12"
        v-show="isStaff"
        :class="{ 'col-lg-3': isStaff }"
      >
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div
        class="col-lg-9 col-md-7 col-sm-12"
        :class="{ 'col-lg-12': !isStaff }"
      >
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-6 com-md-9 col-sm-12 d-flex justify-content-start"
              ></div>
              <div
                class="col-lg-6 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px"
                  class="ml-2"
                />
                <ts-button
                  v-show="isStaff"
                  outline
                  class="ml-2"
                  v-tooltip="$t('filter')"
                  @click.prevent="visible = true"
                >
                  <i class="fa fa-filter"></i>
                </ts-button>
              </div>
            </div>
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template v-slot="{ record }">
              <td>
                {{ record.branch !== null ? record.branch.branch_name_en : '' }}
              </td>
              <td>{{ $store.getters.limitStringShow(record.event_name) }}</td>
              <td>{{ record.event_start_date }}</td>
              <td>{{ record.event_end_date }}</td>
              <td>
                {{ $store.getters.limitStringShow(record.event_criteria) }}
              </td>
              <td class="text-center">
                <a
                  v-show="isStaff"
                  href="#"
                  v-tooltip="$t('edit')"
                  class="text-primary mr-2"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  v-show="isStaff"
                  href="#"
                  v-tooltip="$t('delete')"
                  class="text-danger"
                  @click.prevent="destroy(record)"
                >
                  <i class="fas fa-spin fa-spinner" v-if="record._deleting"></i>
                  <i class="fas fa-trash" v-else></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
    <a-drawer
      :title="$t('filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <ts-branch-filter @filter="value => (branch_id = value)" />
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'event',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      route_leave: false,
      branch_id: [],
      visible: false,
      columns: [
        { name: this.$t('event.branch') },
        { name: this.$t('event.name') },
        { name: this.$t('event.startdate') },
        { name: this.$t('event.enddate') },
        { name: this.$t('event.criteria') },
        {
          name: this.$t('event.Actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    if (this.isParent) {
      this.branch_id = []
      this.branch_id.push(this.$store.state.selectedStudent.branch_id)
    } else {
      this.fetchData()
    }
  },
  computed: {
    ...mapState('event', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.event.search
      },
      set(newVal) {
        this.$store.commit('event/SET_SEARCH', newVal)
        this.$store.commit('event/RESET_CURRENT_PAGE')
      }
    },
    isStaff() {
      return this.$store.getters.isStaffLogin
    },
    isParent() {
      return this.$store.getters.isParentLogin
    },
    selectedStudent() {
      return this.$store.state.selectedStudent.student_id
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch(
          'event/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.route_leave = false
      this.edit_data = data
      this.$router.push(`/events/${data.event_id}`)
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('event/delete', record.event_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500),
    selectedStudent: debounce(function() {
      if (this.isParent) {
        this.branch_id = []
        this.branch_id.push(this.$store.state.selectedStudent.branch_id)
      }
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'event-create') {
      this.$store.commit('event/RESET_STATE')
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
